import { createContext } from 'react';
import PropTypes from 'prop-types';

const PostcodeSelectorContext = createContext();

const PostcodeSelectorProvider = ({
  id,
  dispatch,
  postcode,
  setPostcodeSearched,
  setPostcodeIsReset,
  fetchedAddresses,
  addressList,
  selectedAddress,
  showManualEntryButton,
  setValue,
  errors,
  setError,
  clearErrors,
  children,
}) => (
  <PostcodeSelectorContext.Provider
    value={{
      id,
      dispatch,
      postcode,
      setPostcodeSearched,
      setPostcodeIsReset,
      fetchedAddresses,
      addressList,
      selectedAddress,
      showManualEntryButton,
      setValue,
      errors,
      setError,
      clearErrors,
    }}>
    {children}
  </PostcodeSelectorContext.Provider>
);

PostcodeSelectorProvider.propTypes = {
  id: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  postcode: PropTypes.string.isRequired,
  setPostcodeSearched: PropTypes.func.isRequired,
  setPostcodeIsReset: PropTypes.func.isRequired,
  fetchedAddresses: PropTypes.arrayOf(
    PropTypes.shape({
      shortname: PropTypes.string.isRequired,
      line1: PropTypes.string.isRequired,
      line2: PropTypes.string,
      line3: PropTypes.string,
      line4: PropTypes.string,
      postcode: PropTypes.string.isRequired,
    }),
  ),
  addressList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedAddress: PropTypes.shape({
    shortname: PropTypes.string,
    line1: PropTypes.string,
    line2: PropTypes.string,
    line3: PropTypes.string,
    line4: PropTypes.string,
    postcode: PropTypes.string,
  }),
  showManualEntryButton: PropTypes.bool.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  setError: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export { PostcodeSelectorContext, PostcodeSelectorProvider };
